import * as BX from "main";
import {Reflection} from 'main.core';
import {Tabs} from './src/tabs';
import {Gallery} from "./src/gallery";

const namespace = Reflection.namespace('BX.Citrus.Aproduction3.Catalog.Element');

export class ElementTemplate {
    constructor() {

        this.tabs = new Tabs();
        this.gallery = new Gallery();

        this.initSpecs();
    }

    initSpecs() {
        this.specsLink = document.querySelector('.b-features__link');

        $(document.body).on('click', '.b-features__link', event => {
            event.preventDefault();

            const firstSpecsTable = $('.b-specifications__table').get(0);
            if (!firstSpecsTable) {
                return;
            }

            const scrollIntoView = () => {
                firstSpecsTable.scrollIntoView({block: 'start', behavior: 'smooth'})
            };
            if (this.tabs.activeIndex !== 0) {
                this.tabs.setActive(0, scrollIntoView);
            }
            else {
                scrollIntoView();
            }
        });
    }

}

namespace.Template = ElementTemplate;
